import {
  BLOCKER_ID,
  POPUP_IMAGE_ID,
  showSiteBlocker,
  hideSiteBlocker,
  getTransitionTime,
  showElementTransition,
  hideElementTransition } from '../components/popup';

document.addEventListener('DOMContentLoaded', function() {
  const TRANSITION_SPEED = 'fast';
  const SITE_BLOCKER = $(BLOCKER_ID);

  const POPUP_IMAGE_BUTTON = $('.image__fullscreen .figure__wrapper');
  const POPUP_IMAGE = $(POPUP_IMAGE_ID);
  const POPUP_IMAGE_CLOSE = $('#site-popup__image .site-popup__image-content .btn.btn--close');

  // Toggle click on fixed contact button
  if (POPUP_IMAGE.length > 0) {
    POPUP_IMAGE.each(function() {
      if ($(this).attr('data-show-permanent') === '1') {
        showSiteBlocker(SITE_BLOCKER, TRANSITION_SPEED, POPUP_IMAGE_ID);
        showElementTransition(POPUP_IMAGE, TRANSITION_SPEED);
      }
    });
  }

  async function addImageToPopup(_caller) {
    const imageSource = _caller.parent('.image__fullscreen').data('lightbox-image');

    if (typeof imageSource === 'undefined' || imageSource.length === 0) {
      return false;
    }

    try {
      const dimensions = await imageDimensions(imageSource);

      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      let imageHeight = dimensions.height;
      let imageWidth = dimensions.width;
      let ratio;

      if (imageHeight > windowHeight * 0.85) {
        ratio = (100 * (windowHeight * 0.85)) / imageHeight;
        imageHeight = windowHeight * 0.85;
        imageWidth = (imageWidth * ratio) / 100;
      }

      if (imageWidth > windowWidth * 0.85) {
        ratio = (100 * (windowWidth * 0.85)) / imageWidth;
        imageWidth = windowWidth * 0.85;
        imageHeight = (imageHeight * ratio) / 100;
      }

      let img = $('<img>');
      img.attr('src', imageSource);
      img.attr('width', imageWidth);
      img.attr('height', imageHeight);
      POPUP_IMAGE.find('.image-container').html(img);
      return true;
    } catch (error) {
      return false;
    }
  }

  const imageDimensions = (src) =>
    new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => {
        const { naturalWidth: width, naturalHeight: height } = img;
        resolve({ width, height });
      };

      img.onerror = () => {
        reject('Image couldn\'t be loaded.');
      };
      img.src = src;
    });

  POPUP_IMAGE_BUTTON.click(function(e) {
    e.preventDefault();
    if (!POPUP_IMAGE.hasClass('active')) {
      showSiteBlocker(SITE_BLOCKER, TRANSITION_SPEED, POPUP_IMAGE_ID);
      showElementTransition(POPUP_IMAGE, TRANSITION_SPEED);
      addImageToPopup($(this));
    } else {
      closePopupImage();
    }
  });

  // Click on close x
  POPUP_IMAGE_CLOSE.click(function(e) {
    e.preventDefault();
    closePopupImage();
  });

  // Close popup function
  function closePopupImage() {
    hideSiteBlocker(SITE_BLOCKER, TRANSITION_SPEED);
    hideElementTransition(POPUP_IMAGE, TRANSITION_SPEED);
  }

  // Expose closePopupImage to be callable programmatically
  window.closePopupImage = closePopupImage;

});
